<template>
    <div class="youtube youtube-block" ref="youtubeblock">
        <div v-if="error">
            <p class="alert alert-danger">Error loading Youtube video..</p>
        </div>
        <PageMarketingConsent
            v-else-if="consent"
            @consent:acceptMarketing="acceptMarketing"
        />
        <div v-else>
            <div v-if="isLoading">
                <Loader />
            </div>
            <div v-else>
                <div class="row">
                    <!-- Display video preview -->
                    <div class="col-xs-12">
                        <YoutubeVideoPreview
                            v-if="video"
                            :video="video"
                            :channel="channel"
                            :horizontalPreview="horizontalPreview"
                            :simplePreview="simplePreview"
                            :texts="texts"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
import axios from 'axios';
import YoutubeVideoPreview from './YoutubeVideoPreview';
import PageMarketingConsent from '../Consent/PageMarketingConsent';
import { hasMarketingConsent } from '../Consent/consentUtil';
import Loader from '../components/Loader.vue';
import { logger } from '../utils/logger.ts';

export default defineComponent({
    name: 'YoutubeBlock',
    components: {
        YoutubeVideoPreview,
        PageMarketingConsent,
        Loader,
    },
    props: {
        blockId: { type: String },
        horizontalPreview: { type: Boolean },
        simplePreview: { type: Boolean },
    },
    data() {
        return {
            isLoading: true,
            error: false,
            consent: false,
            video: {},
            channel: {},
            texts: {},
        };
    },
    mounted() {
        logger.debug('YoutubeBlock mounted, blockId:', this.blockId);
        logger.debug('hasMarketingConsent:', hasMarketingConsent());
        if (hasMarketingConsent()) {
            this.showYoutubeVideo();
        } else {
            this.consent = true;
            this.isLoading = false;
        }
    },
    methods: {
        acceptMarketing() {
            this.consent = false;
            this.showYoutubeVideo();
        },
        async showYoutubeVideo() {
            logger.debug('showYoutubeVideo called, blockId:', this.blockId);
            try {
                const url = `/api/youtube/getvideo/?blockId=${this.blockId}`;
                logger.debug('Fetching:', url);
                const response = await axios.get(url);

                this.video = response.data.video;
                this.channel = response.data.channel;
                this.texts = response.data.texts;

                // Hide loader
                this.isLoading = false;

                // Display error message if video is not returned
                if (this.video) {
                    this.error = false;
                } else {
                    this.error = true;
                }
            } catch (error) {
                logger.error('Error loading youtube video:', error);
                this.isLoading = false;
                this.error = true;
            }
            finally {
                logger.debug('showYoutubeVideo finished');
            }
        },
    },
});
</script>
<style></style>
